import React from "react";
import { RemittanceRequiredCategory } from "@/features/my-order/features/order-history/types";
import StatusBadge from "@/shared/components/StatusBadge";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  status: RemittanceRequiredCategory;
}

function RemittanceRequiredStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();
  const refinedStatus = status === "ADJUSTMENT" ? "PRODUCT" : status;

  return (
    <StatusBadge
      status={tTitle(
        `order_history:invoice.remittance_required_category.${refinedStatus.toLowerCase()}`
      )}
      colorVariant={"red"}
      size={"medium"}
    />
  );
}

export default RemittanceRequiredStatusBadge;
